module.exports = __webpack_public_path__ + "img/subir-archivo.68d5bd50.png";